import { MenuLinks } from '@/constants/menu'
import { PermissionTypes } from '@/constants/permissions'
import PermissionGuard from '@/components/guards/PermissionGuard'
import Dashboard from '@/pages/dashboard'
import { Navigate } from 'react-router-dom'
import PrivateRoute from './PrivateRoute'
import type { RoutesProps } from './utils'

export const dashboardRoutes: RoutesProps = {
	path: MenuLinks.Dashboard,
	name: 'Dashboards',
	icon: 'home',
	header: 'Navigation',
	element: (
		<PermissionGuard permission={[PermissionTypes.Permissions_Dashboard_View, PermissionTypes.Permissions_Tenants_View]}>
			<Dashboard />
		</PermissionGuard>
	),
	route: PrivateRoute,
	children: [
		{
			path: '/',
			name: 'Root',
			element: <Navigate to={MenuLinks.Dashboard} />,
			route: PrivateRoute,
		},
	],
}
